import React, { Component } from 'react';
import { numbersWithComma } from '../../utils/utils';

const airIcon = 'https://cdn.shippingcart.com/assets/001-plane-20230321064808.svg';
const seaIcon = 'https://cdn.shippingcart.com/assets/037-cargo-ship-20230321064815.svg';

class ComputationBreakdown extends Component {
  state = { 
  }

  handleIcon = (type) => {
    return type === 'air'? airIcon : seaIcon;
  }

  renderBreakdown = () => {
    if (this.props.data[this.props.type].usd && this.props.data[this.props.type].usd.single_parcel_fixed_rate) {
      return (
        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
          <span style={{fontSize: '13px', fontWeight: 600, color: '#323232', textTransform: 'capitalize'}}>Fixed Air Cargo Fee</span>
          <span style={{fontSize: '13px', fontWeight: 600, color: '#323232'}}>
            {`USD ${this.props.data[this.props.type].usd.total_cargo || 0.00}`}
          </span>
        </div>
      )
    }
    return (
        <div>
          <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '20px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontSize: '13px', fontWeight: 600, color: '#636363'}}>Chargeable weight</span>
            <span>{this.props.data[this.props.type].usd.total_chargeable_weight} lbs</span>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontSize: '13px', fontWeight: 600, color: '#636363', textTransform: 'capitalize'}}>{this.props.type} Cargo rate</span>
            <span><span style={{ marginRight: '5px' }}>X</span> {`USD ${this.props.data[this.props.type].usd.per_pound_value || 0.00}`}</span>
          </div>
          {this.props.data[this.props.type] && 
            this.props.data[this.props.type].usd.is_sea_higher_rate && <div style={{fontSize: '10px', fontStyle: 'italic'}}>Higher rates apply if any side of a package is over {this.props.minChargableWeight && this.props.minChargableWeight.sea_max_dimension.value} inches.</div>}
        </div>
        <div style={{borderBottom : '1px solid #F1F1F1', paddingBottom: '10px', marginTop: '10px'}}>
          <div style={{display: 'flex', justifyContent: 'right', fontSize: '13px', fontWeight: 600, color: '#323232'}}>
          {`USD ${this.props.data[this.props.type].usd.total_chargeable_amount || 0.00}`}
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span style={{fontSize: '13px', fontWeight: 600, color: '#636363'}}>Fixed handling fee</span>
            <span><span style={{ marginRight: '5px' }}>+</span> 
            {`USD ${numbersWithComma(this.props.data[this.props.type].usd.total_fixed_rate && this.props.data[this.props.type].usd.total_fixed_rate.toFixed(2)) || 0.00}`}
          </span>
          </div>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
          <span style={{fontSize: '13px', fontWeight: 600, color: '#323232', textTransform: 'capitalize'}}>Total {this.props.type} Cargo Fee</span>
          <span style={{fontSize: '13px', fontWeight: 600, color: '#323232'}}>
            {`USD ${this.props.data[this.props.type].usd.total_cargo || 0.00}`}
          </span>
        </div>
      </div>  
    )
  }

  render() {
    return (
      <div>
        {this.props.data.hasOwnProperty('air') && this.props.data.hasOwnProperty('sea') && this.props.type === 'sea' && <div style={{border: '1px solid #E2E2E2', width: '100%'}}/>}
        <div style={{padding: '20px 16px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
              <img src={this.handleIcon(this.props.type)} alt='air' width={24}/>
              <div style={{display: 'flex', flexDirection: 'column', marginLeft: '5px'}}>
                <span style={{fontSize: '16px', color: '#323232', fontWeight: 600, textTransform: 'capitalize'}}>{this.props.type} Cargo</span>
                <span style={{fontSize: '10px', color: '#707070'}}>Est. delivery: {this.props.data.delivery[this.props.type]}</span>
              </div>
            </div>
            <div style={{fontSize: '16px', color: '#0375D9', fontWeight: 600, alignSelf: 'center'}}>
            {this.props.data[this.props.type].total_qty || 0} item/s
            </div>
          </div>
          {this.renderBreakdown()}
        </div>
      </div>
    )
  }
}
export default ComputationBreakdown;


/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/ComputationBreakdown.js
 **/